import { useEffect, useState } from "react";
import CustomButton from "../../../../components/custom/button";
import CustomInput from "../../../../components/custom/input";
import { AccountDetailsValues } from "./ProfilePageTypes";
import { AccountDetailsValidation } from "./validations/accountDetailsValidation";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import SaveIcon from "@mui/icons-material/Save";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import { showSnackbar } from "../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import {
  emailVarificationAsync,
  getProfileDataAsync,
  updateProfileDataAsync,
} from "../../../../../app/slices/profileSlice/ProfileSlice";
import AccountDetailsSkeleton from "../skelitons/AccountDetailsSkeleton";
import { CheckCircleOutline } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
} from "@mui/material";
import CustomDialog from "../../../../components/custom/dialog";
import { ChangeEmail } from "./settings/ChangeEmail";
import dayjs, { Dayjs } from "dayjs";
export const AccountDetails = () => {
  const dispatch = useAppDispatch();
  const initialState: AccountDetailsValues = {
    phone_number: "+91 ",
    first_name: "",
    last_name: "",
    email: "",
    gender: "",
    dob: "",
  };
  const [modalType, setModalType] = useState("");
  // const [selectedAddress, setSelectedAddress] = useState("home");

  const onModalSelection = (type: string, id?: any) => {
    let payload: any = profileData;

    dispatch(updateProfileDataAsync(payload));
    setModalType(type);
  };
  const modalClose = () => {
    setModalType("");
  };
  const [profileData, setProfileData] = useState(initialState);
  const [errors, setErrors] = useState<Partial<AccountDetailsValues>>({});
  const profileDataState = useAppSelector(
    (state) => state.ProfileState?.profileData
  );
  const { updateLoader, emailVerificationLoader } = useAppSelector(
    (state) => state.ProfileState
  );
  const { email_verified } =
    useAppSelector((state) => state.ProfileState?.profileData?.data) || false;
  const inputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;

    setProfileData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    let curErrors: Partial<AccountDetailsValues> = { ...errors };
    delete curErrors[name as keyof AccountDetailsValues];
    const fieldErrors: Partial<AccountDetailsValues> = AccountDetailsValidation(
      {
        ...profileData,
        [name]: value,
      }
    );
    if (fieldErrors[name as keyof AccountDetailsValues]) {
      curErrors[name as keyof AccountDetailsValues] =
        fieldErrors[name as keyof AccountDetailsValues];
    }
    setErrors(curErrors);
  };

  useEffect(() => {
    dispatch(getProfileDataAsync()).then((response: any) => {
      if (response?.payload?.status === 200) {
        const ResponseData = response?.payload?.data?.data;
        setProfileData(ResponseData);
      }
    });
  }, [updateLoader]);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    let curErrors: any = { ...errors };
    delete curErrors["gender"];
    setErrors(curErrors);
    setProfileData({
      ...profileData,
      gender: value,
    });
  };
  const handleDateChange = (newDate: Dayjs | null) => {
    // let curErrors: any = { ...errors };
    // delete curErrors["date"]; // Adjust the key based on your validation

    // setErrors(curErrors);
    let curErrors: any = { ...errors };
    delete curErrors["dob"];
    setErrors(curErrors);
    const formattedDate = newDate ? newDate.format("YYYY-MM-DD") : null;

    setProfileData({
      ...profileData,
      dob: formattedDate,
    });
  };

  const saveDetails = () => {
    const errorCheck = AccountDetailsValidation(profileData);

    if (Object.keys(errorCheck).length === 0) {
      let payload: any = profileData;

      dispatch(updateProfileDataAsync(payload)).then((response: any) => {
        if (response?.payload?.status === 200) {
          dispatch(
            showSnackbar({
              message: "Profile is updated succesfuly.",
              severity: "success",
              autoHide: 2000,
            })
          );
          dispatch(getProfileDataAsync());
        } else {
          dispatch(
            showSnackbar({
              message: "Please try again later.",
              severity: "error",
              autoHide: 3000,
            })
          );
        }
      });
    } else {
      setErrors(errorCheck);
    }
  };
  const emailVarification = () => {
    dispatch(emailVarificationAsync()).then((response: any) => {
      if (response?.payload?.status === 200) {
        dispatch(
          showSnackbar({
            message:
              "A verification email has been sent to your email address. Please click the link in that email to verify your account.",
            severity: "success",
            autoHide: 2000,
          })
        );
      } else {
        let errorMessage = response?.payload?.data?.message;
        dispatch(
          showSnackbar({
            message: errorMessage ? errorMessage : "Please try again later.",
            severity: "error",
            autoHide: 3000,
          })
        );
      }
    });
  };
  const formatDateForDisplay = (dateString: string | null) => {
    if (!dateString) return "";
    return dayjs(dateString).format("DD/MM/YY"); // Format date for display
  };

  return (
    <>
      <div className="my-account-content account-edit">
        <h4 className="title-right">Edit Profile</h4>
        <div className="card p-5">
          <form className="" id="" action="#">
            {profileDataState?.loader ? (
              <AccountDetailsSkeleton />
            ) : (
              <div className="row">
                <div className="col-md-6">
                  <div className="tf-field style-1 mb_15">
                    <CustomInput
                      label="First Name"
                      name="first_name"
                      required
                      size="small"
                      value={profileData?.first_name}
                      onChange={inputChange}
                      variant="outlined"
                      error={!!errors?.first_name}
                      fullWidth
                      helperText={errors?.first_name}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="tf-field style-1 mb_15">
                    <CustomInput
                      label="Last Name"
                      name="last_name"
                      // required
                      size="small"
                      onChange={inputChange}
                      value={profileData?.last_name || ""}
                      variant="outlined"
                      error={!!errors?.last_name}
                      fullWidth
                      helperText={errors?.last_name}
                    />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="tf-field style-1 mb_15">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        maxDate={dayjs().subtract(5, "year")}
                        minDate={dayjs().subtract(100, "year")}
                        format="DD-MM-YYYY"
                        value={
                          profileData?.dob ? dayjs(profileData?.dob) : null
                        }
                        onChange={(newDate) => handleDateChange(newDate)}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            size: "small",
                            error: !!errors.dob,
                            helperText: errors.dob ? errors.dob : "",
                            placeholder: "Select your date of birth",
                            inputProps: {
                              placeholder: "Select your date of birth",
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-md-7">
                  <div
                    className="tf-field style-1 mb_15"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <FormControl
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        style={{ marginRight: "16px" }}
                      >
                        Gender
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={profileData?.gender}
                        onChange={handleRadioChange}
                      >
                        <FormControlLabel
                          value="male"
                          control={<Radio />}
                          label="Male"
                        />
                        <FormControlLabel
                          value="female"
                          control={<Radio />}
                          label="Female"
                        />
                        <FormControlLabel
                          value="prefer_not_to_say"
                          control={<Radio />}
                          label="Prefer not to say"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="tf-field style-1 mb_15">
                    <CustomInput
                      type="tel"
                      label="Mobile Number"
                      name="phone_number"
                      size="small"
                      required
                      disabled
                      onChange={inputChange}
                      value={profileData?.phone_number}
                      variant="outlined"
                      error={!!errors?.phone_number}
                      fullWidth
                      helperText={errors?.phone_number}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="tf-field style-1 mb_15">
                    <CustomInput
                      type="email"
                      label="Email"
                      name="email"
                      size="small"
                      value={profileData?.email}
                      onChange={inputChange}
                      variant="outlined"
                      // error={!!errors?.email}
                      disabled
                      fullWidth
                      // helperText={errors?.email}
                      // focused
                      loader={profileDataState?.loader}
                      endIcon={
                        email_verified ? (
                          <CheckCircleOutline color="success" />
                        ) : (
                          <Tooltip title="Please verify your email.">
                            <InfoIcon color="info" />
                          </Tooltip>
                        )
                      }
                      // InputProps={{
                      //   endAdornment: (
                      //     <InputAdornment position="end">
                      //       <CheckIcon />
                      //     </InputAdornment>
                      //   ),
                      // }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="tf-field style-1 mb_15">
                    <CustomButton
                      size="medium"
                      fullWidth
                      onClick={() => onModalSelection("changeEmail")}
                      name={profileData?.email ? "Edit Email" : "Add"}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="tf-field style-1 mb_15">
                    <CustomButton
                      loader={emailVerificationLoader}
                      color={email_verified ? "success" : "primary"}
                      endIcon={
                        email_verified ? (
                          <TaskAltIcon />
                        ) : (
                          <PublishedWithChangesIcon />
                        )
                      }
                      size="medium"
                      fullWidth
                      onClick={emailVarification}
                      name={email_verified ? "Verified" : "Verify"}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-10"></div>
              <div className="col-md-2">
                <CustomButton
                  endIcon={<SaveIcon />}
                  onClick={saveDetails}
                  loader={updateLoader}
                  size="medium"
                  fullWidth
                  name="Save"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <CustomDialog
        component={
          <ChangeEmail emailProp={profileData?.email} modalClose={modalClose} />
        }
        title={profileData?.email ? "Change" : "Add"}
        openDialog={modalType === "changeEmail"}
        handleCloseDialog={modalClose}
        modalPlace="center"
      />
    </>
  );
};
